module.exports = __webpack_public_path__ + "static/media/empty.83fcdc31.gif";